import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { DocumentDataProvider } from "../../data-provider/document.dp";
import { Campaign } from "../../models/campaign.model";
import { Oauth2Service } from "../../services/oauth2.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let CreateAppDialog = {
    selector: "vcCreateAppDialog",
    templateUrl: "/angular/components/profile/create-app-dialog.component.html",
    bindings: {
        selectedApp: "=",
    },
    controller: class CreateAppDialogController {
        // * bindings for typescript compiler *
        public selectedApp: any;
        // ************************************

        public icons = [];
        public uploader: any;
        public activeCampaign: Campaign;
        public app: any;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private $cookies: any;

        private oAuth2Service: Oauth2Service;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            $cookies: any,
            Oauth2Service: Oauth2Service,
            CampaignDataProvider: CampaignDataProvider,
            DocumentDataProvider: DocumentDataProvider
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.$cookies = $cookies;

            this.oAuth2Service = Oauth2Service;

            this.uploader = DocumentDataProvider.getFileUploader(4); //TODO push onto icons array
            this.activeCampaign = CampaignDataProvider.setActiveCampaign(
                this.$cookies.getObject("campaign")
            );
        }

        $onInit() {
            if (this.selectedApp) {
                this.app = _.cloneDeep(this.selectedApp);
            } else {
                this.app = {
                    aname: "",
                    adescription: "",
                    acallbackurl: "",
                    app_type: 1,
                };
            }
        }

        saveApp(application: any): void {
            if (this.icons.length) {
                application.dcid = this.icons[0].dcid;
                application.icon_url = this.icons[0].url;
            }
            application.selectedCampaignid = this.activeCampaign.campaignid;
            if (application.oaclid) {
                this.oAuth2Service
                    .updateApp(application)
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            json.data.icon_url = application.icon_url;
                            this.dialog.hide(json.data);
                        }
                    });
            } else {
                this.oAuth2Service
                    .createApp(application)
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            json.data.icon_url = application.icon_url;
                            this.dialog.hide(json.data);
                        }
                    });
            }
        }

        removeIcon(): void {
            this.icons.splice(0, 2);
            this.app.icon_url = null;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        openDeleteAppDialog(ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: `Delete App?`,
                        bodyText: `They will be permanently deleted`,
                    },
                })
                .then(() => {
                    this.oAuth2Service
                        .delete({ id: this.app.oaclid })
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.toast.success("Application Deleted");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }
    },
};

angular.module("profile").component(CreateAppDialog.selector, CreateAppDialog);
